import { FormFieldValidationErrorResponse } from './FormFieldValidationErrorResponse';

export type FormValidationErrorResponse =
  FormFieldValidationErrorResponse[];
